import { useEffect, useState } from 'react';
import { getSurveys } from '@/lib/api';
import { useLenis } from '@/hooks/useLenis';
import VisitorCounter from '@/components/VisitorCounter';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import Marquee from '@/components/Marquee';
import Flagship from '@/components/Flagship';
import SurveyGrid from '@/components/SurveyGrid';
import HowItWorks from '@/components/HowItWorks';
import AiAssistant from '@/components/AiAssistant';
import VideoSection from '@/components/VideoSection';
import SeoArticle from '@/components/SeoArticle';
import Footer from '@/components/Footer';

export default function Home() {
    useLenis();
    const [featured, setFeatured] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const list = await getSurveys();
                const flag = list.find((s) => s.is_featured) || list[0];
                setFeatured(flag);
            } catch (e) {
                console.error(e);
            }
        })();
    }, []);

    return (
        <div className="grain relative bg-sand-100 text-ink min-h-screen">
            <VisitorCounter />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <HowItWorks />
                <SurveyGrid />
                <AiAssistant />
                <VideoSection />
                <Flagship survey={featured} />
                <SeoArticle />
            </main>
            <Footer />
        </div>
    );
}
